import React from 'react';
import {
 PrimaryButton, Pulse, SecondaryButton 
} from 'wf-react-component-library';
import ItemApi from '../api/virs/ItemApi';
import Premiums from './Premiums';
import { validatePremium, validatePremiumItem } from '../services/validation/VirmItem';

import './AddPremium.scss';
import { Logger } from '@aws-amplify/core';

const logger = new Logger('AddPremium.js');

class AddPremium extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedItems: this.props.selectedItems,
            isSaving: false,
            premiumErrorMessages: {}
        };
    }

    handleSaveAndClose = () => {
        const { selectedItems } = this.state;
        const promises = [];
        this.setState({ isSaving: true });
        let premiumErrors;

        // since the same premium is applied across all the items, let's just check the premium on the firt item
        if ('premium' in selectedItems[0] && Object.getOwnPropertyNames(selectedItems[0].premium).length !== 0) {
            const premiumValidation = validatePremium(selectedItems[0].premium);
            const itemValidation = validatePremiumItem(selectedItems[0]);
            premiumErrors = { ...premiumValidation.errors, ...itemValidation.errors };
        }

        if (!premiumErrors || Object.keys(premiumErrors).length === 0) {
            selectedItems.forEach(selectedItem => {
                promises.push(ItemApi.patch(selectedItem.vendorId, selectedItem, selectedItem.vendorItemId))
            });

            Promise.all(promises).then(_ => {
                this.setState({ isSaving: false });
                this.props.closeModal();
            });
        } else {
            this.setState({ isSaving: false, premiumErrorMessages: premiumErrors })
        }
    }

    handlePremiumChange = (premium) => {
        const { selectedItems } = this.state;
        let premiumErrors = {};
        selectedItems.forEach(selectedItem => {
            selectedItem.premium = {...premium};
            selectedItem.isDirty = true;
            const itemValidation = validatePremiumItem(selectedItem);
            premiumErrors = {...premiumErrors, ...itemValidation.errors}
        });
        const premiumValidation = validatePremium(selectedItems[0].premium);
        premiumErrors = { ...premiumErrors, ...premiumValidation.errors };

        this.setState({ selectedItems, premiumErrorMessages: premiumErrors === null ? {} : premiumErrors });
    }

    render() {
      const { selectedItems }  = this.props;
      const { isLoading, premiumErrorMessages } = this.state;

      const selectedItem = selectedItems[0];
      selectedItem.premium = selectedItem.premium ? selectedItem.premium : {};

      return (
            <div className="flex-container-row item-details-container show">
                <div className="flex-container-row items-all">
                    {isLoading
                        ? <Pulse text='Saving Premiums...' />
                        : selectedItems.map(item => <div className="premium-item" key={item.vendorItemId}>{`${item.itemId} - ${item.description}`}</div>)
                    }
                </div>
                <div className="flex-container-row edit-premiums">
                    <Premiums premiumErrorMessages={premiumErrorMessages} selectedItem={selectedItem} currentVendorCategory={this.props.currentVendorCategory} handlePremiumChange={this.handlePremiumChange} />
                </div>

                <div className="flex-container-row edit-action-buttons">
                    <PrimaryButton onClick={this.handleSaveAndClose} name="Save and Close" />
                    <SecondaryButton onClick={this.props.closeModal} name="Return to Dashboard" />
                </div>
            </div>
        );
    }
}

export default AddPremium;
